<template>
  <v-row>
    <!-- payment successfull -->
    <v-col class="col-6 offset-3 mt-12">
      <v-card outlined>
        <v-card-text>
          <v-row>
            <v-col class="col-4 text-right">
              <span class="fal fa-check fa-4x green--text" />
            </v-col>
            <v-col class="col-6 text-left headline-large mt-6">
              {{ $t('booking.cashPaymentSuccessful') }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col class="col-6 offset-3">
      <v-card outlined>
        <v-card-text>
          <v-row>
            <!-- back to cash desk -->
            <v-col class="col-4">
              <v-btn
                color="red"
                class="white--text"
                x-large
                @click="$router.push({ name: 'cashDesk' })"
              >
                <span class="fal fa-cash-register mr-2" />
                {{ $t('bookingPaid.backToCashDesk') }}
              </v-btn>
            </v-col>

            <!-- print group receipt -->
            <v-col class="col-4 text-center">
              <v-btn
                color="primary"
                x-large
                @click="
                  $router.push({
                    name: 'groupReceiptByBookingId',
                    params: {
                      id: bookingId,
                      previousRoute: { name: 'cashDesk' },
                    },
                  })
                "
              >
                <i class="fal fa-users fa-2x mr-2" />
                {{ $t('paymentDetails.printGroupReceipt') }}
              </v-btn>
            </v-col>

            <!-- print tickets -->
            <v-col class="col-4 text-right">
              <v-btn
                color="green"
                class="white--text"
                x-large
                @click="
                  $router.push({
                    name: 'printTicketsByBookingId',
                    params: {
                      id: bookingId,
                      previousRoute: { name: 'cashDesk' },
                    },
                  })
                "
              >
                <i class="fal fa-print fa-2x mr-2" />
                {{ $t('shopBackendBookingDetail.printAllTickets') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'BookingPaid',

  props: {
    bookingId: {
      required: true,
      type: Number,
    },
  },
}
</script>
